import React from "react";

const SecondaryButton = ({ text, color, Icon, onClick }) => {
  return (
    <button
      onClick={onClick}
      // We use template literals (``) to swap the text color class dynamically
      className={`bg-white ${color} border font-medium text-sm px-6 py-4 rounded-lg shadow-sm hover:shadow-lg duration-300 transition-all flex flex-row items-center overflow-hidden group`}
    >
      {/* If an Icon is provided, it will show up here */}
      {Icon && (
        <Icon className="text-xl w-0 opacity-0 group-hover:w-6 group-hover:opacity-100 group-hover:mr-2 transition-all duration-300 ease-in-out" />
      )}
      {text}
    </button>
  );
};

export default SecondaryButton;
